var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FFEDE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6378 16.7625L15.6734 18.7689C16.28 19.3669 16.28 20.3456 15.6734 20.9436C15.079 21.5295 14.1242 21.5295 13.5298 20.9436L8.94504 16.4244C8.15036 15.6411 8.15036 14.3589 8.94504 13.5756L13.5298 9.05643C14.1242 8.47053 15.079 8.47053 15.6734 9.05643C16.28 9.65439 16.28 10.6331 15.6734 11.2311L13.6378 13.2375L21.7437 13.2426C22.7139 13.2433 23.5 14.0299 23.5 15C23.5 15.9701 22.7139 16.7567 21.7438 16.7574L13.6378 16.7625Z",
    fill: "url(#paint0_linear_2978_21453)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2978_21453",
    x1: 15.5254,
    y1: -1.8,
    x2: 26.5547,
    y2: 23.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4A35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.3d4af023edbf955902d227840295b781.svg";
export { ForwardRef as ReactComponent };